import React from "react";
import "./About.scss";
import { useLanguage } from "../../../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about-container">
      <section className="about-section">
        <div className="about-section__overlay"></div>

        <div className="about-section__content container">
          <h1 className="about-section__title">{t("aboutUsTitle")}</h1>
          <p className="about-section__subtitle">{t("aboutUsSubtitle")}</p>

          <div className="about-info">
            <div className="about-info__row">
              <div className="about-info__column">
                <h2 className="about-info__title">{t("aboutHoufTitle")}</h2>
                <p className="about-info__text">{t("aboutUsText")}</p>
              </div>
              <div className="about-info__column">
                <h2 className="about-info__title">{t("visionMissionTitle")}</h2>
                <p className="about-info__text">{t("missionText")}</p>
              </div>
            </div>

            <div className="about-info__row">
              <div className="about-info__column">
                <h2 className="about-info__title">{t("valuesTitle")}</h2>
                <p className="about-info__text">{t("valuesText")}</p>
              </div>
              <div className="about-info__column">
                <h2 className="about-info__title">{t("experienceTitle")}</h2>
                <p className="about-info__text">{t("experienceText")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
